module.exports = __webpack_public_path__ + "media/images/default/pages/treatment_features/introduces/05-5ada8be60398b5d009e3d3dc791c57ff.jpg";